
// import React, { useState, useRef, useEffect, useCallback } from "react";
// import Platform from "../Platform/Platform";
// import {
//   Box, TextField, Button, Typography, MenuItem,
//   Paper, CircularProgress, Avatar, IconButton,
//   Dialog, DialogContent, Slide, Select, FormControl
// } from "@mui/material";
// import {api} from "../Login/axiosConfig";
// import ReactMarkdown from "react-markdown";
// import Header1 from "../Header/Header1";
// import ExpertRecommendations from "./ExpertRecommendations";
// import SendIcon from "@mui/icons-material/Send";
// import SmartToyIcon from "@mui/icons-material/SmartToy";
// import PersonIcon from "@mui/icons-material/Person";
// import GroupsIcon from "@mui/icons-material/Groups";
// import CloseIcon from "@mui/icons-material/Close";
// import StopIcon from "@mui/icons-material/Stop";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import BookingModal from "../Chatbot/BookingModel";

// const API_URL = process.env.REACT_APP_API_URL;

// // ─── Constants ───────────────────────────────────────────────────────────────
// const SIDEBAR_WIDTH = 60;          // px — matches Platform drawerWidth
// const HEADER_HEIGHT = 64;          // px — matches Header1 height
// const TYPING_SPEED_MS = 18;        // ms per character — natural feel
// const MODEL_OPTIONS = [
//   { value: "openai",   label: "OpenAI" },
//   { value: "qween",    label: "Qween" },
//   { value: "llama",    label: "Llama" },
//   { value: "mistral",  label: "Mistral-7B" },
// ];

// // ─── Transition for dialog ───────────────────────────────────────────────────
// const Transition = React.forwardRef((props, ref) => (
//   <Slide direction="up" ref={ref} {...props} />
// ));

// // ─── Streaming hook ──────────────────────────────────────────────────────────
// function useTypingEffect() {
//   const queueRef    = useRef("");      // characters yet to render
//   const timerRef    = useRef(null);
//   const onTickRef   = useRef(null);    // callback(char, isDone)

//   const start = useCallback((fullText, onTick) => {
//     clearInterval(timerRef.current);
//     queueRef.current = fullText;
//     onTickRef.current = onTick;

//     timerRef.current = setInterval(() => {
//       if (!queueRef.current.length) {
//         clearInterval(timerRef.current);
//         onTickRef.current?.("", true);
//         return;
//       }
//       // Drain 2–3 chars per tick for speed without jank
//       const chunk = queueRef.current.slice(0, 2);
//       queueRef.current = queueRef.current.slice(2);
//       onTickRef.current?.(chunk, false);
//     }, TYPING_SPEED_MS);
//   }, []);

//   const stop = useCallback(() => {
//     clearInterval(timerRef.current);
//     // Flush remaining
//     if (queueRef.current) {
//       onTickRef.current?.(queueRef.current, true);
//       queueRef.current = "";
//     }
//   }, []);

//   useEffect(() => () => clearInterval(timerRef.current), []);

//   return { start, stop };
// }

// // ─── Blinking cursor component ───────────────────────────────────────────────
// function Cursor() {
//   return (
//     <Box
//       component="span"
//       sx={{
//         display: "inline-block",
//         width: "2px",
//         height: "1em",
//         background: "#2b8cff",
//         ml: "2px",
//         verticalAlign: "text-bottom",
//         animation: "blink 1s step-end infinite",
//         "@keyframes blink": { "0%,100%": { opacity: 1 }, "50%": { opacity: 0 } },
//       }}
//     />
//   );
// }

// // ─── Single message bubble ───────────────────────────────────────────────────
// const MessageBubble = React.memo(function MessageBubble({
//   msg, idx, onViewExperts, userData,
// }) {
//   const isUser = msg.role === "user";
//   const initial = userData?.name ? userData.name.charAt(0).toUpperCase() : null;

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: isUser ? "flex-end" : "flex-start",
//         mb: 3,
//         maxWidth: { xs: "100%", sm: "85%", md: "75%" },
//         ml: isUser ? "auto" : 0,
//         mr: isUser ? 0 : "auto",
//         // MODIFIED: fade + slide-up entrance animation
//         animation: "msgIn 0.28s ease both",
//         "@keyframes msgIn": {
//           from: { opacity: 0, transform: "translateY(10px)" },
//           to:   { opacity: 1, transform: "translateY(0)" },
//         },
//       }}
//     >
//       {/* Avatar + name row */}
//       <Box sx={{
//         display: "flex", alignItems: "center", gap: 1, mb: 0.5,
//         flexDirection: isUser ? "row-reverse" : "row",
//       }}>
//         {/* MODIFIED: user avatar uses initials, matching Header1 logic */}
//         {isUser ? (
//           <Avatar
//             sx={{
//               width: 28, height: 28,
//               bgcolor: "#0e4686",
//               fontSize: "0.75rem",
//               fontWeight: 700,
//               border: "1px solid rgba(43,140,255,0.4)",
//             }}
//             src={userData?.image ? userData.image : undefined}
//           >
//             {!userData?.image && initial ? initial : <PersonIcon sx={{ fontSize: 14 }} />}
//           </Avatar>
//         ) : (
//           <Avatar sx={{
//             width: 28, height: 28, bgcolor: "#1a1a2e",
//             border: "1px solid rgba(43,140,255,0.3)",
//           }}>
//             <SmartToyIcon sx={{ fontSize: 16, color: "#2b8cff" }} />
//           </Avatar>
//         )}
//         <Typography sx={{ fontSize: "0.72rem", color: "#555", userSelect: "none" }}>
//           {isUser ? (userData?.name || "You") : "AI Assistant"}
//         </Typography>
//       </Box>

//       {/* Bubble */}
//       <Box sx={{
//         px: { xs: 2, sm: 2.5 }, py: 1.5,
//         borderRadius: isUser ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
//         background: isUser
//           ? "linear-gradient(135deg, #2b8cff, #1a6fd4)"
//           : "rgba(255,255,255,0.04)",
//         border: !isUser ? "1px solid rgba(255,255,255,0.07)" : "none",
//         backdropFilter: !isUser ? "blur(8px)" : "none",
//         maxWidth: "100%",
//         wordBreak: "break-word",
//         "& p":  { margin: 0, color: isUser ? "white" : "#ddd", lineHeight: 1.7 },
//         "& h2, & h3": { color: "#2b8cff" },
//         "& code": {
//           background: "rgba(43,140,255,0.15)", px: 0.5, borderRadius: "4px",
//           fontSize: "0.85em", color: "#6ea8ff",
//         },
//         "& pre": {
//           background: "rgba(0,0,0,0.4)", p: 1.5, borderRadius: "8px",
//           overflow: "auto", fontSize: "0.85rem",
//         },
//         "& ul, & ol": { color: "#ddd", pl: 2 },
//       }}>
//         {isUser ? (
//           <Typography sx={{ color: "white", lineHeight: 1.6, fontSize: { xs: "0.9rem", sm: "1rem" } }}>
//             {msg.text}
//           </Typography>
//         ) : (
//           <>
//             <ReactMarkdown
//               components={{
//                 h2: ({ node, ...props }) => <h2 style={{ color: "#2b8cff", marginTop: 8 }} {...props} />,
//                 h3: ({ node, ...props }) => <h3 style={{ color: "#2b8cff", marginTop: 8 }} {...props} />,
//                 p:  ({ node, ...props }) => <p  style={{ color: "#ddd", lineHeight: 1.7, fontSize: "0.95rem" }} {...props} />,
//                 code: ({ node, ...props }) => <code style={{ background: "rgba(43,140,255,0.15)", padding: "2px 6px", borderRadius: 4, color: "#6ea8ff" }} {...props} />,
//               }}
//             >
//               {msg.text}
//             </ReactMarkdown>
//             {/* MODIFIED: blinking cursor while streaming */}
//             {msg.streaming && <Cursor />}
//           </>
//         )}
//       </Box>

//       {/* Experts button — only when streaming done */}
//       {!isUser && !msg.streaming && msg.experts?.length > 0 && (
//         <Button
//           size="small"
//           startIcon={<GroupsIcon sx={{ fontSize: 14 }} />}
//           onClick={() => onViewExperts(msg.experts)}
//           sx={{
//             mt: 1, borderRadius: "20px",
//             fontSize: "0.73rem", px: 1.8, py: 0.4,
//             color: "#00ffa3",
//             border: "1px solid rgba(0,255,163,0.3)",
//             background: "rgba(0,255,163,0.05)",
//             transition: "all 0.2s ease",
//             "&:hover": {
//               background: "rgba(0,255,163,0.12)",
//               border: "1px solid rgba(0,255,163,0.6)",
//               transform: "translateY(-1px)",
//             },
//           }}
//         >
//           View {msg.experts.length} Expert{msg.experts.length > 1 ? "s" : ""}
//         </Button>
//       )}
//     </Box>
//   );
// });

// // ─── Dots typing indicator ────────────────────────────────────────────────────
// function TypingDots() {
//   return (
//     <Box sx={{
//       display: "flex", alignItems: "center", gap: 1, mb: 3,
//       animation: "msgIn 0.28s ease both",
//       "@keyframes msgIn": { from: { opacity: 0, transform: "translateY(8px)" }, to: { opacity: 1, transform: "translateY(0)" } },
//     }}>
//       <Avatar sx={{ width: 28, height: 28, bgcolor: "#1a1a2e", border: "1px solid rgba(43,140,255,0.3)" }}>
//         <SmartToyIcon sx={{ fontSize: 16, color: "#2b8cff" }} />
//       </Avatar>
//       <Box sx={{
//         px: 2.5, py: 1.5, borderRadius: "18px 18px 18px 4px",
//         background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)",
//       }}>
//         <Box sx={{ display: "flex", gap: "5px", alignItems: "center", height: 20 }}>
//           {[0, 1, 2].map(i => (
//             <Box key={i} sx={{
//               width: 6, height: 6, borderRadius: "50%", background: "#2b8cff",
//               animation: "bounce 1.2s infinite",
//               animationDelay: `${i * 0.2}s`,
//               "@keyframes bounce": {
//                 "0%, 80%, 100%": { transform: "scale(0.55)", opacity: 0.35 },
//                 "40%":           { transform: "scale(1)",    opacity: 1 },
//               },
//             }} />
//           ))}
//         </Box>
//       </Box>
//     </Box>
//   );
// }

// // ─── Model selector pill ──────────────────────────────────────────────────────
// // MODIFIED: moved to input row (rendered inside input bar)
// function ModelPill({ value, onChange }) {
//   return (
//     <Select
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//       variant="outlined"
//       size="small"
//       IconComponent={KeyboardArrowDownIcon}
//       sx={{
//         height: 46,
//         minWidth: { xs: 100, sm: 118 },
//         flexShrink: 0,
//         borderRadius: "14px",
//         background: "rgba(255,255,255,0.04)",
//         color: "#aaa",
//         fontSize: "0.78rem",
//         "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(43,140,255,0.18)" },
//         "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(43,140,255,0.45)" },
//         "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(43,140,255,0.6)" },
//         "& .MuiSvgIcon-root": { color: "#555", fontSize: 16 },
//         "& .MuiSelect-select": { py: "10px", pl: "12px", pr: "28px !important" },
//         backdropFilter: "blur(8px)",
//       }}
//       MenuProps={{
//         PaperProps: {
//           sx: {
//             background: "#111827",
//             border: "1px solid rgba(43,140,255,0.18)",
//             borderRadius: "12px",
//             mt: 0.5,
//             "& .MuiMenuItem-root": {
//               fontSize: "0.82rem", color: "#ccc", py: 0.8,
//               "&:hover":    { background: "rgba(43,140,255,0.12)" },
//               "&.Mui-selected": { background: "rgba(43,140,255,0.18)", color: "#6ea8ff" },
//             },
//           },
//         },
//       }}
//     >
//       {MODEL_OPTIONS.map(opt => (
//         <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
//       ))}
//     </Select>
//   );
// }

// // ─── Main component ───────────────────────────────────────────────────────────
// export default function ChatbotUI({ onLogout, userId, userData }) {
//   const [messages,       setMessages]       = useState([]);
//   const [input,          setInput]          = useState("");
//   const [model,          setModel]          = useState("openai");
//   const [loading,        setLoading]        = useState(false);   // network pending
//   const [streaming,      setStreaming]      = useState(false);   // typing effect active
//   const [expertsDialog,  setExpertsDialog]  = useState(false);
//   const [currentExperts, setCurrentExperts] = useState([]);
//   const [selectedExpert, setSelectedExpert] = useState(null);
//   const [limitReached, setLimitReached] = useState(false);
//   const bottomRef  = useRef(null);
//   const inputRef   = useRef(null);
//   const { start: startTyping, stop: stopTyping } = useTypingEffect();

//   // ── Auto-scroll ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     bottomRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages, loading, streaming]);



//   // ── Open experts dialog ────────────────────────────────────────────────────
//   const handleViewExperts = useCallback((experts) => {
//     setCurrentExperts([...experts]);
//     setExpertsDialog(false);
//     setTimeout(() => setExpertsDialog(true), 0);
//   }, []);

//   // ── Interrupt streaming ────────────────────────────────────────────────────
//   const handleInterrupt = useCallback(() => {
//     stopTyping();
//     setStreaming(false);
//     // Mark last ai message as done
//     setMessages(prev => {
//       const copy = [...prev];
//       const last = copy[copy.length - 1];
//       if (last?.streaming) copy[copy.length - 1] = { ...last, streaming: false };
//       return copy;
//     });
//   }, [stopTyping]);

//   // ── Send message ───────────────────────────────────────────────────────────
//   const handleSend = useCallback(async () => {
//     if (!input.trim() || loading || streaming) return;

//     const userMessage = { role: "user", text: input };
//     setMessages(prev => [...prev, userMessage]);
//     setInput("");
//     setLoading(true);

//     try {
//       const token = localStorage.getItem("access_token");
//       const res = await api.post(
//         `${API_URL}/api/chatbot/ask/`,
//         { question: input, model_used: model },
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
//       );
//       if (res.data.error === "Token limit exceeded") {
//           setLimitReached(true);

//   setMessages(prev => [
//     ...prev,
//     {
//       role: "ai",
//       text: "🚫 You’ve reached your weekly limit. Please subscribe to continue.",
//       experts: [],
//       streaming: false
//     }
//   ]);
//   setLoading(false);
//   return;
// }

//       const fullText = res.data.answer || "";
//       const experts  = res.data.recommended_experts || [];

//       // MODIFIED: inject streaming message placeholder, then type into it
//       const msgIdx = (prev => prev.length)(await new Promise(res => {
//         setMessages(prev => {
//           res(prev);
//           return [...prev, { role: "ai", text: "", experts, streaming: true }];
//         });
//       }));

//       setLoading(false);
//       setStreaming(true);

//       startTyping(fullText, (chunk, isDone) => {
//         setMessages(prev => {
//           const copy = [...prev];
//           const last = copy[copy.length - 1];
//           if (!last || last.role !== "ai") return prev;
//           copy[copy.length - 1] = {
//             ...last,
//             text: last.text + chunk,
//             streaming: !isDone,
//           };
//           return copy;
//         });
//         if (isDone) setStreaming(false);
//       });

//     } catch (err) {
//   if (err.response?.status === 403) {
//     setMessages(prev => [
//       ...prev,
//       {
//         role: "ai",
//         text: "🚫 Weekly limit reached. Please subscribe to continue.",
//         experts: [],
//         streaming: false
//       }
//     ]);
//   } else {
//     setMessages(prev => [
//       ...prev,
//       {
//         role: "ai",
//         text: "Error contacting AI service. Please try again.",
//         experts: [],
//         streaming: false
//       }
//     ]);
//   }
//   setLoading(false);
// }
//   }, [input, loading, streaming, model, startTyping]);

//   const handleKeyDown = useCallback((e) => {
//     if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSend(); }
//   }, [handleSend]);

//   const canSend = input.trim() && !loading && !streaming;

//   // ─────────────────────────────────────────────────────────────────────────
//   return (
//     <>
//       {/* Fixed header */}
//       <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1300, background: "#000" }}>
//         <Header1 onLogout={onLogout} />
//       </Box>

//       {/* Sidebar */}
//       <Platform userId={userId} onLogout={onLogout} />

//       {/* Main column */}
//       <Box sx={{
//         display: "flex", flexDirection: "column", height: "100vh",
//         background: "#000",
//         pt: `${HEADER_HEIGHT}px`,
//         // MODIFIED: respect sidebar on desktop, bottom bar on mobile
//         ml: { xs: 0, sm: `${SIDEBAR_WIDTH}px` },
//       }}>

//         {/* ── Messages scroll area ── */}
//         <Box sx={{
//           flex: 1, overflowY: "auto",
//           pt: { xs: "16px", sm: "24px" },
//           // MODIFIED: pb accounts for input bar (model pill + text row) height
//           pb: { xs: "160px", sm: "120px" },
//           px: { xs: 1.5, sm: 3, md: 5 },
//           "&::-webkit-scrollbar":       { width: "4px" },
//           "&::-webkit-scrollbar-track": { background: "transparent" },
//           "&::-webkit-scrollbar-thumb": { background: "rgba(43,140,255,0.25)", borderRadius: "2px" },
//         }}>
//           <Box sx={{ maxWidth: 800, mx: "auto" }}>

//             {/* Empty state */}
//             {messages.length === 0 && !loading && (
//               <Box sx={{
//                 display: "flex", flexDirection: "column",
//                 alignItems: "center", justifyContent: "center",
//                 minHeight: "60vh", gap: 2, userSelect: "none",
//               }}>
//                 <Box sx={{
//                   width: 72, height: 72, borderRadius: "50%",
//                   background: "radial-gradient(circle, rgba(43,140,255,0.15) 0%, transparent 70%)",
//                   display: "flex", alignItems: "center", justifyContent: "center",
//                   border: "1px solid rgba(43,140,255,0.15)",
//                   animation: "pulse 3s ease-in-out infinite",
//                   "@keyframes pulse": {
//                     "0%,100%": { boxShadow: "0 0 0 0 rgba(43,140,255,0.1)" },
//                     "50%":     { boxShadow: "0 0 0 16px rgba(43,140,255,0)" },
//                   },
//                 }}>
//                   <SmartToyIcon sx={{ fontSize: 36, color: "rgba(43,140,255,0.5)" }} />
//                 </Box>
//                 <Typography variant="h5" sx={{
//                   fontWeight: 700, textAlign: "center", fontSize: { xs: "1.2rem", sm: "1.5rem" },
//                   background: "linear-gradient(90deg,#2b8cff,#6ea8ff)",
//                   WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
//                 }}>
//                   How can I help you today?
//                 </Typography>
//                 <Typography sx={{ color: "#444", fontSize: "0.88rem" }}>
//                   Ask anything — I'll recommend experts too
//                 </Typography>
//               </Box>
//             )}

//             {/* Message list */}
//             {messages.map((msg, idx) => (
//               <MessageBubble
//                 key={idx} msg={msg} idx={idx}
//                 onViewExperts={handleViewExperts}
//                 userData={userData}
//               />
//             ))}

//             {/* Loading dots — shown while waiting for network response */}
//             {loading && <TypingDots />}

//             <div ref={bottomRef} />
//           </Box>
//         </Box>

//         {/* ── MODIFIED: Input bar — glassmorphism, model pill + text row ── */}
//         <Box sx={{
//           position: "fixed",
//           bottom: { xs: "60px", sm: 0 },   // 60px = mobile bottom bar
//           left: { xs: 0, sm: `${SIDEBAR_WIDTH}px` },
//           right: 0,
//           zIndex: 100,
//           background: "rgba(0,0,0,0.85)",
//           borderTop: "1px solid rgba(255,255,255,0.05)",
//           backdropFilter: "blur(20px)",
//           WebkitBackdropFilter: "blur(20px)",
//           px: { xs: 1.5, sm: 3, md: 5 },
//           pt: { xs: 1, sm: 1.2 },
//           pb: { xs: 1.2, sm: 1.6 },
//         }}>
//           <Box sx={{ maxWidth: 800, mx: "auto" }}>

//             {/* MODIFIED: model pill + text field + send button in ONE row */}
//             <Box sx={{
//               display: "flex",
//               gap: { xs: "6px", sm: "8px" },
//               alignItems: "flex-end",
//             }}>

//               {/* Model selector pill — left of input */}
//               <ModelPill value={model} onChange={setModel} />

//               {/* Text input */}
//               <TextField
                 
//                 inputRef={inputRef}
//                 multiline maxRows={5} fullWidth
//                 placeholder="Message AI Assistant…"
//                 value={input}
//                 disabled={limitReached} 
//                 onChange={(e) => setInput(e.target.value)}
//                 onKeyDown={handleKeyDown}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: "16px",
//                     background: "rgba(255,255,255,0.04)",
//                     color: "white",
//                     fontSize: { xs: "0.9rem", sm: "0.97rem" },
//                     backdropFilter: "blur(8px)",
//                     transition: "box-shadow 0.25s ease, border-color 0.25s ease",
//                     "& fieldset": { borderColor: "rgba(43,140,255,0.18)", transition: "border-color 0.25s" },
//                     "&:hover fieldset": { borderColor: "rgba(43,140,255,0.42)" },
//                     // MODIFIED: glowing focus ring
//                     "&.Mui-focused fieldset": { borderColor: "#2b8cff" },
//                     "&.Mui-focused": {
//                       boxShadow: "0 0 0 3px rgba(43,140,255,0.12), 0 4px 24px rgba(43,140,255,0.08)",
//                     },
//                   },
//                   "& textarea":              { color: "white" },
//                   "& textarea::placeholder": { color: "#444" },
//                 }}
//               />

//               {/* Send / Stop button */}
//               <IconButton
//                 onClick={streaming ? handleInterrupt : handleSend}
//                 disabled={!canSend && !streaming}
//                 sx={{
//                   width: 46, height: 46, flexShrink: 0, mb: "1px",
//                   borderRadius: "14px",
//                   background: streaming
//                     ? "rgba(255,80,80,0.15)"
//                     : canSend
//                       ? "linear-gradient(135deg,#2b8cff,#4da3ff)"
//                       : "rgba(43,140,255,0.08)",
//                   border: streaming ? "1px solid rgba(255,80,80,0.4)" : "none",
//                   transition: "all 0.22s ease",
//                   "&:hover": {
//                     background: streaming
//                       ? "rgba(255,80,80,0.28)"
//                       : "linear-gradient(135deg,#1f6ed4,#2b8cff)",
//                     transform: "scale(1.06)",
//                     boxShadow: streaming
//                       ? "0 4px 16px rgba(255,80,80,0.2)"
//                       : "0 4px 18px rgba(43,140,255,0.35)",
//                   },
//                   "&:active": { transform: "scale(0.97)" },
//                   "&:disabled": { background: "rgba(43,140,255,0.07)", transform: "none" },
//                 }}
//               >
//                 {streaming
//                   ? <StopIcon sx={{ color: "#ff6060", fontSize: 19 }} />
//                   : <SendIcon sx={{ color: canSend ? "white" : "#2b3a55", fontSize: 19 }} />
//                 }
//               </IconButton>
//             </Box>

//             {/* Hint line */}
//             <Typography sx={{
//               textAlign: "center", fontSize: "0.67rem", color: "#2e2e3e", mt: 0.6, userSelect: "none",
//             }}>
//               Enter to send · Shift+Enter for new line · {streaming ? "click ■ to stop" : ""}
//             </Typography>
//           </Box>
//         </Box>

//         {/* ── Experts Dialog ── */}
//         <Dialog
//           open={expertsDialog}
//           onClose={() => setExpertsDialog(false)}
//           TransitionComponent={Transition}
//           fullWidth maxWidth="lg"
//           PaperProps={{
//             sx: {
//               background: "#0c0c12",
//               border: "1px solid rgba(0,255,163,0.18)",
//               borderRadius: { xs: "16px 16px 0 0", sm: "16px" },
//               m: { xs: 0, sm: 2 },
//               position: { xs: "fixed", sm: "relative" },
//               bottom: { xs: 0, sm: "auto" },
//               maxHeight: { xs: "85vh", sm: "80vh" },
//               overflowY: "auto",
//             },
//           }}
//         >
//           <Box sx={{
//             display: "flex", alignItems: "center", justifyContent: "space-between",
//             p: { xs: 2, sm: 3 }, borderBottom: "1px solid rgba(255,255,255,0.06)",
//             position: "sticky", top: 0, background: "#0c0c12", zIndex: 1,
//           }}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//               <GroupsIcon sx={{ color: "#00ffa3", fontSize: 20 }} />
//               <Typography variant="h6" sx={{ color: "#00ffa3", fontWeight: 600, fontSize: "1rem" }}>
//                 Recommended Experts
//               </Typography>
//             </Box>
//             <IconButton onClick={() => setExpertsDialog(false)} sx={{ color: "#555" }}>
//               <CloseIcon sx={{ fontSize: 18 }} />
//             </IconButton>
//           </Box>
//           <DialogContent sx={{ p: { xs: 1.5, sm: 3 } }}>
//             <ExpertRecommendations
//               experts={currentExperts}
//               onBookSession={(expert) => setSelectedExpert(expert)}
//             />
//           </DialogContent>
//         </Dialog>

//         {/* ── Booking modal ── */}
//         {selectedExpert && (
//           <BookingModal
//             open={Boolean(selectedExpert)}
//             expert={selectedExpert}
//             onClose={() => {
//               setSelectedExpert(null);
//               setExpertsDialog(false);
//             }}
//           />
//         )}
//       </Box>
//     </>
//   );
// }

import React, { useState, useRef, useEffect, useCallback } from "react";
import Platform from "../Platform/Platform";
import {
  Box, TextField, Button, Typography, MenuItem,
  Paper, CircularProgress, Avatar, IconButton,
  Dialog, DialogContent, Slide, Select, Chip, Tooltip
} from "@mui/material";
import { api } from "../Login/axiosConfig";
import ReactMarkdown from "react-markdown";
import Header1 from "../Header/Header1";
import ExpertRecommendations from "./ExpertRecommendations";
import SendIcon from "@mui/icons-material/Send";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import CloseIcon from "@mui/icons-material/Close";
import StopIcon from "@mui/icons-material/Stop";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AddIcon from "@mui/icons-material/Add";
import BookingModal from "../Chatbot/BookingModel";

const API_URL = process.env.REACT_APP_API_URL;

const SIDEBAR_WIDTH  = 60;
const HEADER_HEIGHT  = 64;
const TYPING_SPEED_MS = 18;
const MODEL_OPTIONS = [
  { value: "openai",   label: "OpenAI"      },
  { value: "qween",    label: "Qween"       },
  { value: "llama",    label: "Llama"       },
  { value: "mistral",  label: "Mistral-7B"  },
];

// Allowed file types for RAG
const ALLOWED_TYPES = ["application/pdf", "text/plain", "text/markdown", "text/csv"];
const ALLOWED_EXTS  = [".pdf", ".txt", ".md", ".csv"];
const MAX_FILE_MB   = 10;

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

// ─── Streaming hook (unchanged) ──────────────────────────────────────────────
function useTypingEffect() {
  const queueRef  = useRef("");
  const timerRef  = useRef(null);
  const onTickRef = useRef(null);

  const start = useCallback((fullText, onTick) => {
    clearInterval(timerRef.current);
    queueRef.current  = fullText;
    onTickRef.current = onTick;
    timerRef.current  = setInterval(() => {
      if (!queueRef.current.length) {
        clearInterval(timerRef.current);
        onTickRef.current?.("", true);
        return;
      }
      const chunk = queueRef.current.slice(0, 2);
      queueRef.current = queueRef.current.slice(2);
      onTickRef.current?.(chunk, false);
    }, TYPING_SPEED_MS);
  }, []);

  const stop = useCallback(() => {
    clearInterval(timerRef.current);
    if (queueRef.current) {
      onTickRef.current?.(queueRef.current, true);
      queueRef.current = "";
    }
  }, []);

  useEffect(() => () => clearInterval(timerRef.current), []);
  return { start, stop };
}

// ─── Cursor (unchanged) ──────────────────────────────────────────────────────
function Cursor() {
  return (
    <Box component="span" sx={{
      display: "inline-block", width: "2px", height: "1em",
      background: "#2b8cff", ml: "2px", verticalAlign: "text-bottom",
      animation: "blink 1s step-end infinite",
      "@keyframes blink": { "0%,100%": { opacity: 1 }, "50%": { opacity: 0 } },
    }} />
  );
}

// ─── RAG badge — shown on AI replies that used document context ───────────────
function RagBadge() {
  return (
    <Tooltip title="Answer enhanced with your uploaded document" arrow>
      <Box sx={{
        display: "inline-flex", alignItems: "center", gap: "3px",
        px: "7px", py: "2px", borderRadius: "20px", mt: 0.8,
        background: "rgba(43,140,255,0.08)",
        border: "1px solid rgba(43,140,255,0.22)",
        cursor: "default",
      }}>
        <AutoAwesomeIcon sx={{ fontSize: 11, color: "#6ea8ff" }} />
        <Typography sx={{ fontSize: "0.65rem", color: "#6ea8ff", letterSpacing: "0.02em" }}>
          RAG enhanced
        </Typography>
      </Box>
    </Tooltip>
  );
}

// ─── Message bubble ───────────────────────────────────────────────────────────
const MessageBubble = React.memo(function MessageBubble({ msg, onViewExperts, userData }) {
  const isUser  = msg.role === "user";
  const initial = userData?.name ? userData.name.charAt(0).toUpperCase() : null;

  return (
    <Box sx={{
      display: "flex", flexDirection: "column",
      alignItems: isUser ? "flex-end" : "flex-start",
      mb: 3,
      maxWidth: { xs: "100%", sm: "85%", md: "75%" },
      ml: isUser ? "auto" : 0,
      mr: isUser ? 0 : "auto",
      animation: "msgIn 0.28s ease both",
      "@keyframes msgIn": {
        from: { opacity: 0, transform: "translateY(10px)" },
        to:   { opacity: 1, transform: "translateY(0)"    },
      },
    }}>
      {/* Avatar row */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5, flexDirection: isUser ? "row-reverse" : "row" }}>
        {isUser ? (
          <Avatar sx={{
            width: 28, height: 28, bgcolor: "#0e4686",
            fontSize: "0.75rem", fontWeight: 700, border: "1px solid rgba(43,140,255,0.4)",
          }} src={userData?.image || undefined}>
            {!userData?.image && initial ? initial : <PersonIcon sx={{ fontSize: 14 }} />}
          </Avatar>
        ) : (
          <Avatar sx={{ width: 28, height: 28, bgcolor: "#1a1a2e", border: "1px solid rgba(43,140,255,0.3)" }}>
            <SmartToyIcon sx={{ fontSize: 16, color: "#2b8cff" }} />
          </Avatar>
        )}
        <Typography sx={{ fontSize: "0.72rem", color: "#555", userSelect: "none" }}>
          {isUser ? (userData?.name || "You") : "AI Assistant"}
        </Typography>
      </Box>

      {/* Bubble */}
      <Box sx={{
        px: { xs: 2, sm: 2.5 }, py: 1.5,
        borderRadius: isUser ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
        background: isUser ? "linear-gradient(135deg,#2b8cff,#1a6fd4)" : "rgba(255,255,255,0.04)",
        border: !isUser ? "1px solid rgba(255,255,255,0.07)" : "none",
        backdropFilter: !isUser ? "blur(8px)" : "none",
        maxWidth: "100%", wordBreak: "break-word",
        "& p":  { margin: 0, color: isUser ? "white" : "#ddd", lineHeight: 1.7 },
        "& h2, & h3": { color: "#2b8cff" },
        "& code": { background: "rgba(43,140,255,0.15)", px: 0.5, borderRadius: "4px", fontSize: "0.85em", color: "#6ea8ff" },
        "& pre":  { background: "rgba(0,0,0,0.4)", p: 1.5, borderRadius: "8px", overflow: "auto", fontSize: "0.85rem" },
        "& ul, & ol": { color: "#ddd", pl: 2 },
      }}>
        {/* ── If user message had a file attached, show a small file tag ── */}
        {isUser && msg.fileName && (
          <Box sx={{
            display: "inline-flex", alignItems: "center", gap: "5px",
            mb: 0.8, px: 1, py: "3px", borderRadius: "8px",
            background: "rgba(255,255,255,0.15)",
          }}>
            <InsertDriveFileIcon sx={{ fontSize: 13, color: "rgba(255,255,255,0.8)" }} />
            <Typography sx={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.85)", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {msg.fileName}
            </Typography>
          </Box>
        )}

        {isUser ? (
          <Typography sx={{ color: "white", lineHeight: 1.6, fontSize: { xs: "0.9rem", sm: "1rem" } }}>
            {msg.text}
          </Typography>
        ) : (
          <>
            <ReactMarkdown components={{
              h2:   ({ node, ...p }) => <h2   style={{ color: "#2b8cff",   marginTop: 8 }}                        {...p} />,
              h3:   ({ node, ...p }) => <h3   style={{ color: "#2b8cff",   marginTop: 8 }}                        {...p} />,
              p:    ({ node, ...p }) => <p    style={{ color: "#ddd",      lineHeight: 1.7, fontSize: "0.95rem" }} {...p} />,
              code: ({ node, ...p }) => <code style={{ background: "rgba(43,140,255,0.15)", padding: "2px 6px", borderRadius: 4, color: "#6ea8ff" }} {...p} />,
            }}>
              {msg.text}
            </ReactMarkdown>
            {msg.streaming && <Cursor />}
          </>
        )}
      </Box>

      {/* RAG badge */}
      {!isUser && !msg.streaming && msg.ragUsed && <RagBadge />}

      {/* Experts button */}
      {!isUser && !msg.streaming && msg.experts?.length > 0 && (
        <Button
          size="small" startIcon={<GroupsIcon sx={{ fontSize: 14 }} />}
          onClick={() => onViewExperts(msg.experts)}
          sx={{
            mt: 1, borderRadius: "20px", fontSize: "0.73rem", px: 1.8, py: 0.4,
            color: "#00ffa3", border: "1px solid rgba(0,255,163,0.3)",
            background: "rgba(0,255,163,0.05)", transition: "all 0.2s ease",
            "&:hover": { background: "rgba(0,255,163,0.12)", border: "1px solid rgba(0,255,163,0.6)", transform: "translateY(-1px)" },
          }}
        >
          View {msg.experts.length} Expert{msg.experts.length > 1 ? "s" : ""}
        </Button>
      )}
    </Box>
  );
});

// ─── Typing dots (unchanged) ──────────────────────────────────────────────────
function TypingDots() {
  return (
    <Box sx={{
      display: "flex", alignItems: "center", gap: 1, mb: 3,
      animation: "msgIn 0.28s ease both",
      "@keyframes msgIn": { from: { opacity: 0, transform: "translateY(8px)" }, to: { opacity: 1, transform: "translateY(0)" } },
    }}>
      <Avatar sx={{ width: 28, height: 28, bgcolor: "#1a1a2e", border: "1px solid rgba(43,140,255,0.3)" }}>
        <SmartToyIcon sx={{ fontSize: 16, color: "#2b8cff" }} />
      </Avatar>
      <Box sx={{ px: 2.5, py: 1.5, borderRadius: "18px 18px 18px 4px", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)" }}>
        <Box sx={{ display: "flex", gap: "5px", alignItems: "center", height: 20 }}>
          {[0, 1, 2].map(i => (
            <Box key={i} sx={{
              width: 6, height: 6, borderRadius: "50%", background: "#2b8cff",
              animation: "bounce 1.2s infinite", animationDelay: `${i * 0.2}s`,
              "@keyframes bounce": {
                "0%,80%,100%": { transform: "scale(0.55)", opacity: 0.35 },
                "40%":         { transform: "scale(1)",    opacity: 1    },
              },
            }} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}

// ─── Model selector pill (unchanged) ─────────────────────────────────────────
function ModelPill({ value, onChange }) {
  return (
    <Select
      value={value} onChange={(e) => onChange(e.target.value)}
      variant="outlined" size="small" IconComponent={KeyboardArrowDownIcon}
      sx={{
        height: 46, minWidth: { xs: 100, sm: 118 }, flexShrink: 0,
        borderRadius: "14px", background: "rgba(255,255,255,0.04)",
        color: "#aaa", fontSize: "0.78rem",
        "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(43,140,255,0.18)" },
        "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(43,140,255,0.45)" },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(43,140,255,0.6)" },
        "& .MuiSvgIcon-root": { color: "#555", fontSize: 16 },
        "& .MuiSelect-select": { py: "10px", pl: "12px", pr: "28px !important" },
        backdropFilter: "blur(8px)",
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            background: "#111827", border: "1px solid rgba(43,140,255,0.18)",
            borderRadius: "12px", mt: 0.5,
            "& .MuiMenuItem-root": {
              fontSize: "0.82rem", color: "#ccc", py: 0.8,
              "&:hover":        { background: "rgba(43,140,255,0.12)" },
              "&.Mui-selected": { background: "rgba(43,140,255,0.18)", color: "#6ea8ff" },
            },
          },
        },
      }}
    >
      {MODEL_OPTIONS.map(opt => (
        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
      ))}
    </Select>
  );
}

// ─── Main component ───────────────────────────────────────────────────────────
export default function ChatbotUI({ onLogout, userId, userData }) {
  const [messages,       setMessages]       = useState([]);
  const [input,          setInput]          = useState("");
  const [model,          setModel]          = useState("openai");
  const [loading,        setLoading]        = useState(false);
  const [streaming,      setStreaming]      = useState(false);
  const [expertsDialog,  setExpertsDialog]  = useState(false);
  const [currentExperts, setCurrentExperts] = useState([]);
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [limitReached,   setLimitReached]   = useState(false);

  // ── NEW: file state ────────────────────────────────────────────────────────
  const [attachedFile,   setAttachedFile]   = useState(null);   // File object | null
  const [fileError,      setFileError]      = useState("");     // validation message
  const [uploading,      setUploading]      = useState(false);  // ingestion in progress

  const bottomRef   = useRef(null);
  const inputRef    = useRef(null);
  const fileInputRef = useRef(null);                             // hidden <input type="file">

  const { start: startTyping, stop: stopTyping } = useTypingEffect();

  // ── Auto-scroll ────────────────────────────────────────────────────────────
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading, streaming]);

  // ── Open experts ───────────────────────────────────────────────────────────
  const handleViewExperts = useCallback((experts) => {
    setCurrentExperts([...experts]);
    setExpertsDialog(false);
    setTimeout(() => setExpertsDialog(true), 0);
  }, []);

  // ── Interrupt streaming ────────────────────────────────────────────────────
  const handleInterrupt = useCallback(() => {
    stopTyping();
    setStreaming(false);
    setMessages(prev => {
      const copy = [...prev];
      const last = copy[copy.length - 1];
      if (last?.streaming) copy[copy.length - 1] = { ...last, streaming: false };
      return copy;
    });
  }, [stopTyping]);

  // ── NEW: file picker handler ───────────────────────────────────────────────
  const handleFileChange = useCallback((e) => {
    setFileError("");
    const file = e.target.files?.[0];
    if (!file) return;

    // Extension validation
    const ext = "." + file.name.split(".").pop().toLowerCase();
    if (!ALLOWED_EXTS.includes(ext)) {
      setFileError(`Unsupported type. Allowed: ${ALLOWED_EXTS.join(", ")}`);
      e.target.value = "";
      return;
    }

    // Size validation
    if (file.size > MAX_FILE_MB * 1024 * 1024) {
      setFileError(`File too large. Max ${MAX_FILE_MB} MB.`);
      e.target.value = "";
      return;
    }

    setAttachedFile(file);
    // Reset input value so same file can be re-attached after removal
    e.target.value = "";
  }, []);

  // ── NEW: remove attached file ──────────────────────────────────────────────
  const handleRemoveFile = useCallback(() => {
    setAttachedFile(null);
    setFileError("");
  }, []);

  // ── Send message (modified to support multipart when file attached) ────────
  const handleSend = useCallback(async () => {
    if (!input.trim() || loading || streaming) return;

    const userText     = input;
    const fileSnapshot = attachedFile;           // capture before clearing

    // Append user bubble immediately (with optional fileName tag)
    setMessages(prev => [...prev, {
      role: "user",
      text: userText,
      fileName: fileSnapshot?.name || null,
    }]);
    setInput("");
    setAttachedFile(null);
    setFileError("");
    setLoading(true);

    try {
      const token = localStorage.getItem("access_token");

      let res;

      if (fileSnapshot) {
        // ── multipart/form-data — triggers RAG on backend ──
        setUploading(true);
        const form = new FormData();
        form.append("question",   userText);
        form.append("model_used", model);
        form.append("file",       fileSnapshot);

        res = await api.post(
          `${API_URL}/api/chatbot/ask/`,
          form,
          { headers: { Authorization: `Bearer ${token}` } }
          // Do NOT set Content-Type — browser sets multipart boundary automatically
        );
        setUploading(false);
      } else {
        // ── JSON — normal flow, no change ──
        res = await api.post(
          `${API_URL}/api/chatbot/ask/`,
          { question: userText, model_used: model },
          { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
        );
      }

      // Token limit guard (unchanged)
      if (res.data.error === "Token limit exceeded") {
        setLimitReached(true);
        setMessages(prev => [...prev, {
          role: "ai",
          text: "🚫 You've reached your weekly limit. Please subscribe to continue.",
          experts: [], streaming: false, ragUsed: false,
        }]);
        setLoading(false);
        setUploading(false);
        return;
      }

      const fullText = res.data.answer                || "";
      const experts  = res.data.recommended_experts   || [];
      const ragUsed  = res.data.rag_used              ?? false;   // NEW field from backend

      // Inject streaming placeholder
      await new Promise(resolve => {
        setMessages(prev => {
          resolve();
          return [...prev, { role: "ai", text: "", experts, streaming: true, ragUsed }];
        });
      });

      setLoading(false);
      setStreaming(true);

      startTyping(fullText, (chunk, isDone) => {
        setMessages(prev => {
          const copy = [...prev];
          const last = copy[copy.length - 1];
          if (!last || last.role !== "ai") return prev;
          copy[copy.length - 1] = { ...last, text: last.text + chunk, streaming: !isDone };
          return copy;
        });
        if (isDone) setStreaming(false);
      });

    } catch (err) {
      setUploading(false);
      const text = err.response?.status === 403
        ? "🚫 Weekly limit reached. Please subscribe to continue."
        : "Error contacting AI service. Please try again.";
      setMessages(prev => [...prev, { role: "ai", text, experts: [], streaming: false, ragUsed: false }]);
      setLoading(false);
    }
  }, [input, loading, streaming, model, attachedFile, startTyping]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSend(); }
  }, [handleSend]);

  const canSend = input.trim() && !loading && !streaming;

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <>
      <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1300, background: "#000" }}>
        <Header1 onLogout={onLogout} />
      </Box>

      <Platform userId={userId} onLogout={onLogout} />

      <Box sx={{
        display: "flex", flexDirection: "column", height: "100vh",
        background: "#000", pt: `${HEADER_HEIGHT}px`,
        ml: { xs: 0, sm: `${SIDEBAR_WIDTH}px` },
      }}>

        {/* ── Messages scroll area ── */}
        <Box sx={{
          flex: 1, overflowY: "auto",
          pt: { xs: "16px", sm: "24px" },
          // Extra pb when file chip is visible
          pb: { xs: attachedFile ? "200px" : "160px", sm: attachedFile ? "150px" : "120px" },
          px: { xs: 1.5, sm: 3, md: 5 },
          "&::-webkit-scrollbar":       { width: "4px" },
          "&::-webkit-scrollbar-track": { background: "transparent" },
          "&::-webkit-scrollbar-thumb": { background: "rgba(43,140,255,0.25)", borderRadius: "2px" },
        }}>
          <Box sx={{ maxWidth: 800, mx: "auto" }}>

            {/* Empty state */}
            {messages.length === 0 && !loading && (
              <Box sx={{
                display: "flex", flexDirection: "column",
                alignItems: "center", justifyContent: "center",
                minHeight: "60vh", gap: 2, userSelect: "none",
              }}>
                <Box sx={{
                  width: 72, height: 72, borderRadius: "50%",
                  background: "radial-gradient(circle, rgba(43,140,255,0.15) 0%, transparent 70%)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  border: "1px solid rgba(43,140,255,0.15)",
                  animation: "pulse 3s ease-in-out infinite",
                  "@keyframes pulse": {
                    "0%,100%": { boxShadow: "0 0 0 0 rgba(43,140,255,0.1)" },
                    "50%":     { boxShadow: "0 0 0 16px rgba(43,140,255,0)" },
                  },
                }}>
                  <SmartToyIcon sx={{ fontSize: 36, color: "rgba(43,140,255,0.5)" }} />
                </Box>
                <Typography variant="h5" sx={{
                  fontWeight: 700, textAlign: "center", fontSize: { xs: "1.2rem", sm: "1.5rem" },
                  background: "linear-gradient(90deg,#2b8cff,#6ea8ff)",
                  WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                }}>
                  How can I help you today?
                </Typography>
                <Typography sx={{ color: "#444", fontSize: "0.88rem" }}>
                  Ask anything — attach a PDF/TXT to chat with your document
                </Typography>

                {/* ── NEW: drag-hint chips ── */}
                <Box sx={{ display: "flex", gap: 1, mt: 0.5, flexWrap: "wrap", justifyContent: "center" }}>
                  {["Summarise a PDF", "Extract key points", "Q&A over a document"].map(hint => (
                    <Chip
                      key={hint}
                      label={hint}
                      size="small"
                      onClick={() => setInput(hint)}
                      sx={{
                        background: "rgba(43,140,255,0.07)",
                        border: "1px solid rgba(43,140,255,0.18)",
                        color: "#6ea8ff", fontSize: "0.73rem", cursor: "pointer",
                        "&:hover": { background: "rgba(43,140,255,0.15)" },
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}

            {messages.map((msg, idx) => (
              <MessageBubble
                key={idx} msg={msg}
                onViewExperts={handleViewExperts}
                userData={userData}
              />
            ))}

            {loading && <TypingDots />}
            <div ref={bottomRef} />
          </Box>
        </Box>

        {/* ── Input bar ── */}
        <Box sx={{
          position: "fixed",
          bottom: { xs: "60px", sm: 0 },
          left:   { xs: 0, sm: `${SIDEBAR_WIDTH}px` },
          right: 0,
          zIndex: 100,
          background: "rgba(0,0,0,0.85)",
          borderTop: "1px solid rgba(255,255,255,0.05)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          px: { xs: 1.5, sm: 3, md: 5 },
          pt: { xs: 1, sm: 1.2 },
          pb: { xs: 1.2, sm: 1.6 },
        }}>
          <Box sx={{ maxWidth: 800, mx: "auto" }}>

            {/* ── NEW: file chip row (visible only when a file is attached) ── */}
            {(attachedFile || fileError) && (
              <Box sx={{
                display: "flex", alignItems: "center",
                gap: 1, mb: 0.8,
                animation: "chipIn 0.2s ease both",
                "@keyframes chipIn": {
                  from: { opacity: 0, transform: "translateY(6px)" },
                  to:   { opacity: 1, transform: "translateY(0)"   },
                },
              }}>
                {attachedFile && (
                  <Chip
                    icon={<InsertDriveFileIcon sx={{ fontSize: "14px !important", color: "#6ea8ff !important" }} />}
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <Typography sx={{ fontSize: "0.75rem", color: "#ccc", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {attachedFile.name}
                        </Typography>
                        <Typography sx={{ fontSize: "0.68rem", color: "#555", flexShrink: 0 }}>
                          ({(attachedFile.size / 1024).toFixed(0)} KB)
                        </Typography>
                      </Box>
                    }
                    onDelete={handleRemoveFile}
                    deleteIcon={<CloseIcon sx={{ fontSize: "14px !important", color: "#777 !important" }} />}
                    sx={{
                      height: 28,
                      background: "rgba(43,140,255,0.08)",
                      border: "1px solid rgba(43,140,255,0.22)",
                      borderRadius: "10px",
                      "& .MuiChip-label": { px: "6px" },
                    }}
                  />
                )}
                {/* Uploading indicator (shown during multipart request) */}
                {uploading && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <CircularProgress size={12} sx={{ color: "#2b8cff" }} />
                    <Typography sx={{ fontSize: "0.7rem", color: "#6ea8ff" }}>
                      Indexing document…
                    </Typography>
                  </Box>
                )}
                {/* File error */}
                {fileError && (
                  <Typography sx={{ fontSize: "0.72rem", color: "#ff6060" }}>
                    {fileError}
                  </Typography>
                )}
              </Box>
            )}

            {/* ── Input row: model pill | + button | text field | send ── */}
            <Box sx={{ display: "flex", gap: { xs: "6px", sm: "8px" }, alignItems: "flex-end" }}>

              {/* Model selector */}
              <ModelPill value={model} onChange={setModel} />

              {/* ── NEW: + attach button ── */}
              <Tooltip title={`Attach PDF or TXT (max ${MAX_FILE_MB} MB)`} arrow placement="top">
                <span>   {/* span wrapper so Tooltip works when button is disabled */}
                  <IconButton
                    onClick={() => fileInputRef.current?.click()}
                    disabled={loading || streaming || limitReached}
                    sx={{
                      width: 46, height: 46, flexShrink: 0,
                      borderRadius: "14px",
                      // Highlight when a file is already attached
                      background: attachedFile
                        ? "rgba(43,140,255,0.18)"
                        : "rgba(255,255,255,0.04)",
                      border: attachedFile
                        ? "1px solid rgba(43,140,255,0.5)"
                        : "1px solid rgba(43,140,255,0.18)",
                      transition: "all 0.22s ease",
                      "&:hover": {
                        background: "rgba(43,140,255,0.14)",
                        border: "1px solid rgba(43,140,255,0.45)",
                        transform: "scale(1.05)",
                      },
                      "&:disabled": { opacity: 0.35 },
                    }}
                  >
                    {attachedFile
                      ? <AttachFileIcon sx={{ color: "#2b8cff", fontSize: 19 }} />
                      : <AddIcon        sx={{ color: "#6ea8ff", fontSize: 20 }} />
                    }
                  </IconButton>
                </span>
              </Tooltip>

              {/* Hidden file input */}
              <input
                ref={fileInputRef}
                type="file"
                accept={ALLOWED_EXTS.join(",")}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              {/* Text input */}
              <TextField
                inputRef={inputRef}
                multiline maxRows={5} fullWidth
                placeholder={attachedFile ? `Ask about ${attachedFile.name}…` : "Message AI Assistant…"}
                value={input}
                disabled={limitReached}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "16px",
                    background: "rgba(255,255,255,0.04)",
                    color: "white",
                    fontSize: { xs: "0.9rem", sm: "0.97rem" },
                    backdropFilter: "blur(8px)",
                    transition: "box-shadow 0.25s ease, border-color 0.25s ease",
                    "& fieldset": { borderColor: "rgba(43,140,255,0.18)", transition: "border-color 0.25s" },
                    "&:hover fieldset": { borderColor: "rgba(43,140,255,0.42)" },
                    "&.Mui-focused fieldset": { borderColor: "#2b8cff" },
                    "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(43,140,255,0.12), 0 4px 24px rgba(43,140,255,0.08)" },
                  },
                  "& textarea": { color: "white" },
                  "& textarea::placeholder": { color: "#444" },
                }}
              />

              {/* Send / Stop button */}
              <IconButton
                onClick={streaming ? handleInterrupt : handleSend}
                disabled={!canSend && !streaming}
                sx={{
                  width: 46, height: 46, flexShrink: 0, mb: "1px",
                  borderRadius: "14px",
                  background: streaming
                    ? "rgba(255,80,80,0.15)"
                    : canSend
                      ? "linear-gradient(135deg,#2b8cff,#4da3ff)"
                      : "rgba(43,140,255,0.08)",
                  border: streaming ? "1px solid rgba(255,80,80,0.4)" : "none",
                  transition: "all 0.22s ease",
                  "&:hover": {
                    background: streaming ? "rgba(255,80,80,0.28)" : "linear-gradient(135deg,#1f6ed4,#2b8cff)",
                    transform: "scale(1.06)",
                    boxShadow: streaming ? "0 4px 16px rgba(255,80,80,0.2)" : "0 4px 18px rgba(43,140,255,0.35)",
                  },
                  "&:active":   { transform: "scale(0.97)" },
                  "&:disabled": { background: "rgba(43,140,255,0.07)", transform: "none" },
                }}
              >
                {streaming
                  ? <StopIcon  sx={{ color: "#ff6060",                     fontSize: 19 }} />
                  : <SendIcon  sx={{ color: canSend ? "white" : "#2b3a55", fontSize: 19 }} />
                }
              </IconButton>
            </Box>

            {/* Hint line */}
            <Typography sx={{ textAlign: "center", fontSize: "0.67rem", color: "#2e2e3e", mt: 0.6, userSelect: "none" }}>
              Enter to send · Shift+Enter for new line
              {attachedFile ? " · PDF/TXT attached — RAG mode active" : " · + to attach a document"}
              {streaming ? " · click ■ to stop" : ""}
            </Typography>
          </Box>
        </Box>

        {/* ── Experts Dialog (unchanged) ── */}
        <Dialog
          open={expertsDialog} onClose={() => setExpertsDialog(false)}
          TransitionComponent={Transition} fullWidth maxWidth="lg"
          PaperProps={{
            sx: {
              background: "#0c0c12", border: "1px solid rgba(0,255,163,0.18)",
              borderRadius: { xs: "16px 16px 0 0", sm: "16px" },
              m: { xs: 0, sm: 2 },
              position: { xs: "fixed", sm: "relative" }, bottom: { xs: 0, sm: "auto" },
              maxHeight: { xs: "85vh", sm: "80vh" }, overflowY: "auto",
            },
          }}
        >
          <Box sx={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            p: { xs: 2, sm: 3 }, borderBottom: "1px solid rgba(255,255,255,0.06)",
            position: "sticky", top: 0, background: "#0c0c12", zIndex: 1,
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <GroupsIcon sx={{ color: "#00ffa3", fontSize: 20 }} />
              <Typography variant="h6" sx={{ color: "#00ffa3", fontWeight: 600, fontSize: "1rem" }}>
                Recommended Experts
              </Typography>
            </Box>
            <IconButton onClick={() => setExpertsDialog(false)} sx={{ color: "#555" }}>
              <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Box>
          <DialogContent sx={{ p: { xs: 1.5, sm: 3 } }}>
            <ExpertRecommendations
              experts={currentExperts}
              onBookSession={(expert) => setSelectedExpert(expert)}
            />
          </DialogContent>
        </Dialog>

        {selectedExpert && (
          <BookingModal
            open={Boolean(selectedExpert)}
            expert={selectedExpert}
            onClose={() => { setSelectedExpert(null); setExpertsDialog(false); }}
          />
        )}
      </Box>
    </>
  );
}